import React from 'react';
import { Checkbox } from '@mui/material';
import FormControlLabel from '@material-ui/core/FormControlLabel';



// const [state, setState] = React.useState({
//   checkedA: true,
// });

// const handleChangeCheck = (event) => {
//   setState({ ...state, [event.target.name]: event.target.checked });
// };

{
  /* <CheckBox
  label="Set this as most popular"
  checked={state.checkedB}
  onChange={handleChangeCheck}
  color="primary"
/> */
}

function CheckBox(props) {
  const { checked, onChange, label, color, disabled, name, helperText } = props;

  return (
    <div className="PM_CheckBox">
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={onChange}
            name={name}
            color={color}
            disabled={disabled}
          />
        }
        label={label}
      />
      {helperText && <p className="PM_Error-Msg">{helperText}</p>}
    </div>
  );
}

export default CheckBox;
